function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import PictureComponent from "components/core/picture/picture-component";
import SignupButton from "segments/desktop/core-components/button/signup-button/signup-button";
import { WHITE_COLOR_NAME } from "styles/color-consts";
import { CRM_PRODUCT_ID, DEV_PRODUCT_ID, WORK_MANAGEMENT_PRODUCT_ID } from "constants/products";
import { setCookie } from "services/cookies-service";
import { INSTALL_PRODUCTS_FLOW, MULTIPLE_PRODUCTS_SELECTION, SKIP_AB_TESTS_HP } from "constants/cookies";
import { cookieValues, procuctIdToCluster } from "segments/desktop/homepage-first-fold/layouts/monday-products-homepage-first-fold/consts";
import { CLUSTER_TYPE } from "constants/clusters/types";
import { updateUserClustersListWithMultipleClusters } from "services/clusters-service";
import { HP_TAGS_SELECTION } from "constants/clusters";
import { SM } from "constants/sizes";
import DefaultProps from "./default-props";
import { StyledProductSignUp } from "./product-sign-up.scss";
const PRODUCT_TYPE_TO_IMAGE = {
    [CRM_PRODUCT_ID]: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202023/Multi%20products/Global-zoom/Frame_1261162032.png",
    [DEV_PRODUCT_ID]: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202023/Multi%20products/Global-zoom/Frame_1261162033.png",
    [WORK_MANAGEMENT_PRODUCT_ID]: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202023/Multi%20products/Global-zoom/Frame_1261162031.png"
};
const ProductSignUp = (_param)=>{
    var { displayImage, useCtaText, buttonSize, withButtonArrow, ctaText, productType = WORK_MANAGEMENT_PRODUCT_ID, selectedProductIds = [], signupClusterId, useCtaIcon, buttonColor = WHITE_COLOR_NAME, invert, beforeSubmitCallback, excludeFromWMHighIntentExperienceTest } = _param, restOfConfig = _object_without_properties(_param, [
        "displayImage",
        "useCtaText",
        "buttonSize",
        "withButtonArrow",
        "ctaText",
        "productType",
        "selectedProductIds",
        "signupClusterId",
        "useCtaIcon",
        "buttonColor",
        "invert",
        "beforeSubmitCallback",
        "excludeFromWMHighIntentExperienceTest"
    ]);
    const getProductsCookiesKey = ()=>{
        if (selectedProductIds.length === 1) {
            return selectedProductIds[0];
        }
        if (selectedProductIds.length === 2) {
            const sortedIds = selectedProductIds.sort();
            return `${sortedIds[0]}_${sortedIds[1]}`;
        }
        return null;
    };
    const updateClusters = ()=>{
        const res = [];
        if (selectedProductIds.length < 3) {
            selectedProductIds.forEach((id)=>{
                const clusterId = procuctIdToCluster[id];
                if (clusterId) res.push({
                    clusterId,
                    clusterType: CLUSTER_TYPE
                });
            });
            updateUserClustersListWithMultipleClusters(res, HP_TAGS_SELECTION);
        }
    };
    const addTestCookiesAndClusters = (cookieKey)=>{
        setCookie(SKIP_AB_TESTS_HP, true, {
            expires: 1 // 1 day
        });
        setCookie(MULTIPLE_PRODUCTS_SELECTION, true, {
            expires: 1 // 1 day
        });
        const productsKey = cookieKey || getProductsCookiesKey();
        if (productsKey) {
            const cookieArray = cookieValues[productsKey];
            cookieArray === null || cookieArray === void 0 ? void 0 : cookieArray.forEach((cookie)=>{
                setCookie(cookie.key, cookie.value, {
                    expires: 1 // 1 day
                });
            });
        } else {
            setCookie(INSTALL_PRODUCTS_FLOW, false, {
                expires: 1 // 1 day
            });
        }
        updateClusters();
    };
    return /*#__PURE__*/ _jsxs(StyledProductSignUp, {
        className: "product-sign-up",
        children: [
            displayImage ? /*#__PURE__*/ _jsx("div", {
                className: "product-logo-image",
                children: /*#__PURE__*/ _jsx(PictureComponent, {
                    src: PRODUCT_TYPE_TO_IMAGE[productType]
                })
            }) : null,
            /*#__PURE__*/ _jsx(SignupButton, _object_spread_props(_object_spread({}, restOfConfig), {
                withButtonArrow: withButtonArrow,
                useCtaIcon: useCtaIcon,
                productIdToUse: productType,
                signupClusterId: signupClusterId,
                useCtaText: useCtaText,
                ctaText: ctaText,
                buttonSize: buttonSize !== null && buttonSize !== void 0 ? buttonSize : SM,
                buttonColor: buttonColor,
                invert: invert,
                beforeSubmitCallback: ()=>{
                    addTestCookiesAndClusters(productType);
                    beforeSubmitCallback && beforeSubmitCallback();
                },
                skipUpdateCluster: true,
                signupProductId: productType,
                extraData: {
                    selectedProduct: productType
                },
                excludeFromWMHighIntentExperienceTest: excludeFromWMHighIntentExperienceTest
            }))
        ]
    });
};
export default ProductSignUp;
ProductSignUp.defaultProps = DefaultProps;
